module.exports = __webpack_public_path__ + "img/12.c915a9b7.png";